import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/tooltip/Tooltip';
import {
  CancellationPolicySummaryEntry,
  SeasonalRule,
  SeasonalRulePolicyChannel,
} from 'models/seasonality/SeasonalRule';
import { TFunction } from 'react-i18next';
import {
  DetailsCellTooltipRow,
  DetailsCellTooltipContent,
  DetailsCellText,
} from '../SeasonalRulesTable.styles';

const getShortLabel = (
  entry: CancellationPolicySummaryEntry,
  t: TFunction,
): string | null => {
  if (entry.channel === SeasonalRulePolicyChannel.HOSTFULLY) {
    return entry.displayLabel;
  }
  const key = `pageProperty.seasonality.policyShortLabels.${entry.channel}.${entry.policyCode}`;
  const short = t(key, { defaultValue: '' });
  return short || entry.displayLabel;
};

const DetailsCell = ({ row }: { row: Row<SeasonalRule> }) => {
  const { t } = useTranslation();
  const entries = row.original.cancellationPolicySummary;

  if (!entries?.length) {
    return null;
  }

  const shortText = entries
    .map((entry) => getShortLabel(entry, t))
    .filter((label): label is string => !!label)
    .join(', ');

  const tooltipContent = (
    <DetailsCellTooltipContent>
      {entries.map((entry) => (
        <DetailsCellTooltipRow key={entry.channel}>
          <strong>
            {t(`pageProperty.seasonality.channels.${entry.channel}`)}:
          </strong>{' '}
          {entry.displayLabel}
        </DetailsCellTooltipRow>
      ))}
    </DetailsCellTooltipContent>
  );

  return (
    <Tooltip
      id={`seasonal-rule-details-${row.original.uid}`}
      text={tooltipContent}
      placement="top"
    >
      <DetailsCellText data-testid="seasonal-rule-details-cell">
        {shortText}
      </DetailsCellText>
    </Tooltip>
  );
};

export default DetailsCell;
